// MessageInput.tsx - Message Input Component
// Kullanici mesaj input alani

import { Send } from 'lucide-react'
import { KeyboardEvent, useRef, useState } from 'react'

interface MessageInputProps {
  onSend: (message: string) => void
  disabled?: boolean
  placeholder?: string
}

export default function MessageInput({ onSend, disabled = false, placeholder = 'Mesajinizi yazin...' }: MessageInputProps) {
  const [message, setMessage] = useState('')
  const textareaRef = useRef<HTMLTextAreaElement>(null)

  const handleSend = () => {
    const trimmedMessage = message.trim()

    if (!trimmedMessage || disabled) {return}

    onSend(trimmedMessage)
    setMessage('')

    // Reset textarea height
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'
    }
  }

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    // Enter to send (Shift+Enter for new line)
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSend()
    }
  }

  const handleInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(e.target.value)

    // Auto-resize textarea
    const textarea = e.target
    textarea.style.height = 'auto'
    textarea.style.height = `${Math.min(textarea.scrollHeight, 120)}px`
  }

  return (
    <div style={{
      display: 'flex',
      gap: '8px',
      alignItems: 'flex-end'
    }}>
      {/* Textarea */}
      <textarea
        ref={textareaRef}
        value={message}
        onChange={handleInput}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        disabled={disabled}
        rows={1}
        style={{
          flex: 1,
          padding: '10px 12px',
          border: '1px solid var(--border-color)',
          borderRadius: '8px',
          background: 'var(--card-bg)',
          color: 'var(--text-primary)',
          fontSize: '14px',
          resize: 'none',
          minHeight: '40px',
          maxHeight: '120px',
          fontFamily: 'inherit',
          lineHeight: '1.5'
        }}
      />

      {/* Send button */}
      <button
        onClick={handleSend}
        disabled={disabled || !message.trim()}
        style={{
          width: '40px',
          height: '40px',
          borderRadius: '8px',
          border: 'none',
          background: disabled || !message.trim() ? 'var(--border-color)' : 'var(--primary-color)',
          color: 'white',
          cursor: disabled || !message.trim() ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          transition: 'all 0.2s'
        }}
      >
        <Send size={18} />
      </button>
    </div>
  )
}
